import { serializable, alias, primitive } from "serializr";


export class Students {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("first_name", primitive()))
  name?: string;

  @serializable(alias("dob", primitive()))
  dob?: string;

  @serializable(alias("roll_number", primitive()))
  rollNumber?: string;

  @serializable(alias("board_name", primitive()))
  boardName?: string;

  @serializable(alias("institute_name", primitive()))
  instituteName?: string;

  @serializable(alias("branch_name", primitive()))
  branchName?: string;

  @serializable(alias("class_name", primitive()))
  className?: string;

  @serializable(alias("section_name", primitive()))
  sectionName?: string;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("is_blocked", primitive()))
  isBlocked?: number | boolean;

  @serializable(alias("blocked_reason", primitive()))
  blockedReason?: string;
}
